import Vue from 'vue';
import SuccessModal from './SuccessModal';

const newInstance = (data = {}) => {
    const instance = new Vue({
        data,
        render(createElement) {
            return createElement(SuccessModal, {});
        }
    });
    const component = instance.$mount();

    document.body.appendChild(component.$el);

    const successModal = instance.$children[0];

    return {
        open(props) {
            for (const key in props) {
                if (typeof key !== 'function') {
                    successModal[key] = props[key];
                }
            }

            successModal.visible = true;
        }
    };
};

let successModal = null;

function open(options) {
    successModal = successModal || newInstance();

    successModal.open(options);
}


SuccessModal.install = () => {
    Vue.$successModal = Vue.prototype.$successModal = {
        open(props = {}) {
            open(props);
        }
    };
};

export default SuccessModal;



// WEBPACK FOOTER //
// ./src/components/SuccessModal/index.js